import React, { createContext, useEffect, useRef, useState } from "react";
import {
	OrderInner,
	OrderPageNavigationImg,
	OrderPageNavigationInner,
	OrderPageNavigationWrap,
} from "../../../Order/styled/OrderStyle";
import { getUseListOrder } from "../../hook/ListOrder";
import {
	BookingContentName,
	BookingContentWrap,
	MyBookingContainerMobi,
	MyBookingTableContainer,
} from "../../styled/DesStyled";
import { PriceDetail } from "../../../../../models/Order";
import { Table, TableBody, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { CommonTableHeadCell } from "../../../../controls/components/commonTable/CommonTable";
import BookingTableBody from "../BookingTableBody";
import DialogUpdateOrderAdmin from "../../AdminBooking/UpdateOrderAdmin";
import BookingMobi from "../BookingMobi";
import BookingTableBodyPartner from "./BookingTableBodyPartner";

export default function BookingTablePartner(props: { listOrder: PriceDetail[]; reload: () => void }) {
	const [isDialogLoginOpen, setIsDialogLoginOpen] = useState(false);
	const [orderId, setOrderId] = useState(0);
	return (
		<React.Fragment>
			<MyBookingTableContainer>
				<Table aria-label="simple table">
					<TableHead>
						<TableRow>
							<CommonTableHeadCell align="center">ID</CommonTableHeadCell>
							<CommonTableHeadCell align="center">User</CommonTableHeadCell>
							<CommonTableHeadCell align="center">Bags</CommonTableHeadCell>
							<CommonTableHeadCell align="center"> Amount</CommonTableHeadCell>
							<CommonTableHeadCell align="center"> Drop-off/Pick-up</CommonTableHeadCell>
							<CommonTableHeadCell align="center"> Status</CommonTableHeadCell>
							<CommonTableHeadCell align="center"> Action</CommonTableHeadCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.listOrder.map((val, index) => (
							<BookingTableBodyPartner
								key={index}
								val={val}
								reload={props.reload}
								setIsDialogLoginOpen={setIsDialogLoginOpen}
								setOrderId={setOrderId}
							/>
						))}
					</TableBody>
				</Table>
			</MyBookingTableContainer>
			<MyBookingContainerMobi>
				{props.listOrder.map((val, index) => (
					<BookingMobi
						key={index}
						val={val}
						reload={props.reload}
						setIsDialogLoginOpen={setIsDialogLoginOpen}
						setOrderId={setOrderId}
					/>
				))}
			</MyBookingContainerMobi>

			<DialogUpdateOrderAdmin
				openDialog={isDialogLoginOpen}
				setOpenDialog={setIsDialogLoginOpen}
				orderId={orderId}
				reload={props.reload}
			/>
		</React.Fragment>
	);
}
